import React, { Fragment } from "react";
import "./AppProfile.css";

/// Image
import profileImg from "../../../images/profile/avtar.png";
import PageTitle from "../../layouts/PageTitle";
import { connect } from "react-redux";
import { getProfile } from "../../../store/selectors/AuthSelectors";

const AppProfile = ({ profile }) => {
  const getFieldValue = (value) => (value ? value : "Not Set");
  return (
    <Fragment>
      <PageTitle pageTitle={"User Profile"} profile={profile}/>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="card-title mb-4">
                  <div className="d-flex justify-content-start">
                    <div className="image-container">
                      <img
                        src={profileImg}
                        id="imgProfile"
                        style={{ width: "150px", height: "150px" }}
                        className="img-thumbnail"
                      />
                    </div>
                    <div className="userData" style={{ marginLeft: "20px" }}>
                      <h4
                        className="d-block"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          textAlign: "left",
                        }}
                      >
                        <span>
                          {getFieldValue(profile.firstName) +
                            " " +
                            getFieldValue(profile.lastName)}
                        </span>
                      </h4>
                      <h6 className="" style={{ textTransform: "lowercase" }}>
                        <a href={"mailto:" + getFieldValue(profile.email)}>
                          {getFieldValue(profile.email)}
                        </a>
                      </h6>
                      {profile.employeeNumber && (
                        <h6 className="">
                          Employee Code: {getFieldValue(profile.employeeNumber)}
                        </h6>
                      )}
                      <h6 className="">Role: {getFieldValue(profile.role)}</h6>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="tab-content ml-1" id="myTabContent">
                      <div
                        className="tab-pane fade show active"
                        id="basicInfo"
                        role="tabpanel"
                        aria-labelledby="basicInfo-tab"
                      >
                        <div className="row">
                          <div className="col-sm-3 col-md-2 col-5">
                            <label style={{ fontWeight: "bold" }}>
                              Manager
                            </label>
                          </div>
                          <div
                            className="col-md-8 col-6"
                            style={{
                              fontWeight: "bold",
                              textTransform: "capitalize",
                            }}
                          >
                            {getFieldValue(profile.manager).replace(".", " ")}
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-sm-3 col-md-2 col-5">
                            <label style={{ fontWeight: "bold" }}>
                              Manager Mail Id
                            </label>
                          </div>
                          <div className="col-md-8 col-6">
                            {profile.managerEmail ? (
                              <a href={"mailto:" + profile.managerEmail}>
                                {profile.managerEmail}
                              </a>
                            ) : (
                              <a href={"mailto:" + profile.email}>
                                {profile.email}
                              </a>
                            )}
                          </div>
                        </div>
                        <hr />

                        <div className="row">
                          <div className="col-sm-3 col-md-2 col-5">
                            <label style={{ fontWeight: "bold" }}>
                              Contract
                            </label>
                          </div>
                          <div className="col-md-8 col-6">
                            {getFieldValue(profile.contract)}
                          </div>
                        </div>
                        <hr />


                        <div className="row">
                          <div className="col-sm-3 col-md-2 col-5">
                            <label style={{ fontWeight: "bold" }}>
                              Box Folder Id
                            </label>
                          </div>
                          <div className="col-md-8 col-6">
                            {getFieldValue(profile.folderId).toLowerCase() ==
                            "not set" ? (
                              <>{getFieldValue(profile.folderId)}</>
                            ) : (
                              <a
                                href={`https://ssaihq.app.box.com/folder/${getFieldValue(
                                  profile.folderId
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {getFieldValue(profile.folderId)}
                              </a>
                            )}
                          </div>
                        </div>
                        <hr />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    profile: getProfile(state),
  };
};

export default connect(mapStateToProps)(AppProfile);
